module.exports = __webpack_public_path__ + "static/media/arrow-left.a490ea6f.svg";